var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { postAssessmentRating } from '../services/AssessmentRatingService';
import { iimReviewKeys } from './queryKeys';
/**
 * Thumbs rating for an inspection assessment. The vote lives in the query cache under
 * `iimReviewKeys.assessmentRating(id)` (the API does not return the previous vote) and is
 * set optimistically, then rolled back on error.
 */
export function useAssessmentRating(assessmentId) {
    const queryClient = useQueryClient();
    const queryKey = iimReviewKeys.assessmentRating(assessmentId);
    const { data: vote } = useQuery({
        queryKey,
        queryFn: () => { var _a; return Promise.resolve((_a = queryClient.getQueryData(queryKey)) !== null && _a !== void 0 ? _a : null); },
        enabled: false,
        initialData: null,
        staleTime: Infinity,
        cacheTime: Infinity
    });
    const mutation = useMutation({
        mutationFn: ({ rating, reasonCode, details }) => postAssessmentRating(assessmentId, { rating, reasonCode, details }),
        onMutate: (_a) => __awaiter(this, [_a], void 0, function* ({ rating }) {
            var _b;
            yield queryClient.cancelQueries({ queryKey });
            const previousVote = (_b = queryClient.getQueryData(queryKey)) !== null && _b !== void 0 ? _b : null;
            queryClient.setQueryData(queryKey, rating);
            return { previousVote };
        }),
        onError: (_error, _variables, context) => {
            var _a;
            queryClient.setQueryData(queryKey, (_a = context === null || context === void 0 ? void 0 : context.previousVote) !== null && _a !== void 0 ? _a : null);
        }
    });
    return Object.assign(Object.assign({}, mutation), { vote: vote !== null && vote !== void 0 ? vote : null });
}
